import { withLazy } from 'app/hocs/withLazy'

export const Cart = withLazy(() => import('features/Cart/pages/Cart'))
